module.exports = __webpack_public_path__ + "img/info_icon.7918ec16.svg";